import BinToCountConverter from './BinToCountConverter.js';
import StrikeZoneModelBase from '../../classificators/strikeZoneModel/StrikeZoneModelBase.js';
import { DataBin2D } from '../../valueObjects/index.js';

class InvertBallsBinValueConverter extends BinToCountConverter {
    constructor(strikeZoneModel) {
        super();

        if (!(strikeZoneModel instanceof StrikeZoneModelBase)) {
            throw new TypeError(`strikeZoneModel must inherit from StrikeZoneModelBase`);
        }

        this.strikeZoneModel = strikeZoneModel;
    }

    _getBinValue(bin, resultsPerBin) {
        if (!(bin instanceof DataBin2D)) {
            throw new TypeError('bin must be an instance inheriting from DataBin2D class');
        }
        const binCenterX = (bin.toWhereX() - bin.fromWhereX()) / 2 + bin.fromWhereX();
        const binCenterY = (bin.toWhereY() - bin.fromWhereY()) / 2 + bin.fromWhereY();

        const isBall = !this.strikeZoneModel.isCalledStrike(binCenterX, binCenterY);

        //if (bin.data.length === 0){return isBall ?  -0.01 : 0.01;}

        return bin.data.length * (isBall ? -1 : 1);
    }
}

export default InvertBallsBinValueConverter;